export default [
    {
        path: '',
        name: 'reports',
        component: () => import('./Index.vue'),
    },
];
